import React, { useMemo, useState } from "react";
import { connect } from "react-redux";
import i18n from "utils/I18n";
import { getLevelRenewTime } from "../../utils/DateTimeUtils";
import { enLocaleNumberFormatter, getTranslationField } from "../../utils";
// import RetainInfoModal from "./RetainInfoModal";
import "./RetainMembershipSection.scss";
import { LevelCalculationSource, LevelRetainType } from "utils/CustomEnums";


const SpendMoreAccumulatedSpent = ({
  levelCalculationSource,
  pointsToRetainLevel,
}) => (
  <>
    <label>
      {i18n.t(levelCalculationSource === LevelCalculationSource.PROGRESSION_POINTS ? 'earn' : 'spend')}
    </label>
    <label className="reatain-highlight tag-menu-2">
      {i18n.t(
        levelCalculationSource === LevelCalculationSource.PROGRESSION_POINTS ? 'PP' : 'HKD',
        {
          TPE: enLocaleNumberFormatter(pointsToRetainLevel),
        })}
    </label>
    <label>
      {i18n.t('retainMore')}
    </label>
  </>
)

const SpendMoreTransactionTimes = ({
  orRelation,
  transactionTimesToRetain,
  minimumAmount,
}) => {
  const transactionTimes = enLocaleNumberFormatter(transactionTimesToRetain);
  const transactionAmount = enLocaleNumberFormatter(minimumAmount);
  const textDict = useMemo(() => {
    if (transactionTimesToRetain > 1 && minimumAmount) {
      return {
        start: 'morePurchasesOfMinimumAmountStart',
        middle: 'morePurchasesOfMinimumAmountMiddle',
        end: 'morePurchasesOfMinimumAmountEnd',
      };
    };
    if (transactionTimesToRetain > 1) {
      return {
        start: 'morePurchasesOfAnyStart',
        middle: 'morePurchasesOfAnyMiddle',
        end: 'morePurchasesOfAnyEnd',
      };
    };
    if (minimumAmount) {
      return {
        start: 'oneMorePurchaseOfMinimumAmountStart',
        middle: 'oneMorePurchaseOfMinimumAmountMiddle',
        end: 'oneMorePurchaseOfMinimumAmountEnd',
      };
    }
    return {
      start: 'oneMorePurchaseOfAnyStart',
      middle: 'oneMorePurchaseOfAnyMiddle',
      end: 'oneMorePurchaseOfAnyEnd',
    }
  }, [transactionTimesToRetain, minimumAmount])

  return (
    <>
      <label>
        {i18n.t(orRelation ? 'orMake' : 'make')}
      </label>
      <label>
        {i18n.t(textDict.start)}
      </label>
      <label className="reatain-highlight tag-menu-2">
        {i18n.t(transactionTimesToRetain > 1 ? 'morePurchases' : 'oneMorePurchase', {
          quantity: transactionTimes,
        })}
      </label>
      <label>
        {i18n.t(textDict.middle)}
      </label>
      <label className="reatain-highlight tag-menu-2">
        {
          minimumAmount
            ? i18n.t('HKD', { TPE: transactionAmount })
            : null
        }
        {
          minimumAmount && transactionTimesToRetain > 1
            ? i18n.t('each')
            : null
        }
      </label>
      <label>
        {i18n.t(textDict.end)}
      </label>
    </>
  )
}

const SpendMoreSection = ({
  currentLevelData,
  levelCalculationSource,
  levelRetainType,
  pointsToRetainLevel,
  transactionTimesToRetain,
}) => {
  if (levelRetainType === LevelRetainType.ACCUMULATED_SPENT) {
    return (
      <SpendMoreAccumulatedSpent
        levelCalculationSource={levelCalculationSource}
        pointsToRetainLevel={pointsToRetainLevel}
      />
    )
  }
  if (levelRetainType === LevelRetainType.TRANSACTIONS_TIMES) {
    return (
      <SpendMoreTransactionTimes
        orRelation={false}
        transactionTimesToRetain={transactionTimesToRetain}
        minimumAmount={currentLevelData.minimumAmountOfOneTransactionForRenew}
      />
    )
  }
  return (
    <>
      <SpendMoreAccumulatedSpent
        levelCalculationSource={levelCalculationSource}
        pointsToRetainLevel={pointsToRetainLevel}
      />
      <SpendMoreTransactionTimes
        orRelation
        transactionTimesToRetain={transactionTimesToRetain}
        minimumAmount={currentLevelData.minimumAmountOfOneTransactionForRenew}
      />
    </>
  )
}


const RetainMembershipSection = ({
  language,
  renewDate,
  currentLevelData,
  levelCalculationSource,
  levelRetainType,
  pointsToRetainLevel,
  transactionTimesToRetain,
}) => {
  // const [showModal, setShowModal] = useState(false);

  // const openModal = () => {
  //   setShowModal(true);
  // };
  // const closeModal = () => {
  //   setShowModal(false);
  // };

  const currentLevelName = getTranslationField(currentLevelData, "levelName", language);

  return (
    <div className="home-retain-membership-section d-flex flex-column">
      <div className="retain-title subheading">
        <div>{i18n.t("retainTheMembership")}</div>
        {/* <div onClick={openModal}>
          <img alt="icon" src={"/profile/retainLevel/info.png"} />
        </div> */}
      </div>

      {language === 'en' ? (
        <div className="retain-spend-more tag-menu-1">
          <SpendMoreSection
            currentLevelData={currentLevelData}
            levelCalculationSource={levelCalculationSource}
            levelRetainType={levelRetainType}
            pointsToRetainLevel={pointsToRetainLevel}
            transactionTimesToRetain={transactionTimesToRetain}
          />
          <label>
            {i18n.t('retainDueFirst')}
          </label>
          <label className="reatain-highlight tag-menu-2">
            {getLevelRenewTime(renewDate)}
          </label>
          <label>
            {i18n.t('retainDueLast')}
          </label>
          <label>
            {i18n.t('toRetain', { retainLevelName: currentLevelName })}
          </label>
        </div>
      ) : (
        <div className="retain-spend-more tag-menu-1">
          <label>
            {i18n.t('retainDueFirst')}
          </label>
          <label className="reatain-highlight tag-menu-2">
            {getLevelRenewTime(renewDate)}
          </label>
          <label>
            {i18n.t('retainDueLast')}
          </label>
          <SpendMoreSection
            currentLevelData={currentLevelData}
            levelCalculationSource={levelCalculationSource}
            levelRetainType={levelRetainType}
            pointsToRetainLevel={pointsToRetainLevel}
            transactionTimesToRetain={transactionTimesToRetain}
          />
          <label>
            {i18n.t('toRetain', { retainLevelName: currentLevelName })}
          </label>
        </div>
      )}

      {/* <RetainInfoModal
        showModal={showModal}
        close={closeModal}
      /> */}
    </div>
  );
}

const mapStateToProps = (state) => ({
  language: state.users.language,
  renewDate: state.users.renewDate,
  currentLevelData: state.users.currentLevelData,
  levelCalculationSource: state.users.levelCalculationSource,
  levelRetainType: state.users.levelRetainType,
  pointsToRetainLevel: state.users.pointsToRetainLevel,
  transactionTimesToRetain: state.users.transactionTimesToRetain,
});

export default connect(mapStateToProps)(RetainMembershipSection);
